(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/http"), require("lodash"), require("rxjs"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/http", "lodash", "rxjs"], factory);
	else if(typeof exports === 'object')
		exports["ng2-restangular"] = factory(require("@angular/core"), require("@angular/http"), require("lodash"), require("rxjs"));
	else
		root["ng2-restangular"] = factory(root["@angular/core"], root["@angular/http"], root["lodash"], root["rxjs"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_7__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition